import desktopLeft from './desktopLeft.jpg';
import mobileLeft from './mobileLeft.jpg';
import desktopRight from './desktopRight.jpg';
import mobileRight from './mobileRight.jpg';
export default { desktopLeft, mobileLeft, desktopRight, mobileRight };
